
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
XButton
},
name: 'noAccess',
data () {
return {

}
},
created() {

},
methods:{
relogin() {
localStorage.removeItem('loginData');
this.$router.push({
path: '/'
});
}
}
}



// WEBPACK FOOTER //
// ./src/pages/access.vue